function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import React from "react";
import { trackFAQCategoryClick } from "../../../../../js/feature/gtm-tracking";
var reverseDirection = document.body.classList.contains("page-dir-rtl");
var SearchListNavigation = /*#__PURE__*/function (_React$Component) {
  function SearchListNavigation(props) {
    var _this;
    _classCallCheck(this, SearchListNavigation);
    _this = _callSuper(this, SearchListNavigation, [props]);
    _this.navList = /*#__PURE__*/React.createRef();
    _this.scrollStep = 150;
    _this.state = {
      activeNavLinkIndex: 0,
      listScroll: 0,
      maxListScroll: 0,
      childrenScroll: []
    };
    _this.onNavListScroll = _this.onNavListScroll.bind(_this);
    _this.onPageScroll = _this.onPageScroll.bind(_this);
    return _this;
  }
  _inherits(SearchListNavigation, _React$Component);
  return _createClass(SearchListNavigation, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(previousProps, previousState) {
      var _this$navList;
      if (((_this$navList = this.navList) === null || _this$navList === void 0 ? void 0 : _this$navList.current) !== null) {
        var maxListScroll = this.navList.current.scrollWidth - this.navList.current.clientWidth;
        var childrenScroll = _toConsumableArray(this.navList.current.children).map(function (child) {
          return child.offsetLeft;
        });
        if (previousState.maxListScroll !== maxListScroll) {
          this.setState({
            maxListScroll: maxListScroll,
            childrenScroll: childrenScroll
          });
        }
      }
      if (previousProps.pageScrollOffset !== this.props.pageScrollOffset) {
        this.onPageScroll(this.props.pageScrollOffset);
      }
    }
  }, {
    key: "onPageScroll",
    value: function onPageScroll() {
      var _this2 = this;
      var activeIndex = -1;
      var sections = this.props.contentTypes;
      var correction = window.innerWidth > 767 ? 0 : document.getElementById("resource-center--search").clientHeight + 48;
      sections.map(function (section, index) {
        var sectionTop = document.getElementById(section.id).offsetTop;
        var sectionHeight = document.getElementById(section.id).clientHeight;
        var isSectionActive = _this2.props.pageScrollOffset >= sectionTop - correction && sectionTop - correction + sectionHeight > _this2.props.pageScrollOffset;
        if (isSectionActive) {
          activeIndex = index;
        }
      });
      this.setState({
        activeNavLinkIndex: activeIndex
      });
    }
  }, {
    key: "onNavListScroll",
    value: function onNavListScroll() {
      this.setState({
        listScroll: this.navList.current.scrollLeft
      });
    }
  }, {
    key: "handleScrollToNavLink",
    value: function handleScrollToNavLink(e, scrollToNext) {
      var _this3 = this;
      e.preventDefault();
      var childrenScroll = this.state.childrenScroll;
      var currentForLTR = childrenScroll.findIndex(function (item, index) {
        return _this3.navList.current.scrollLeft >= item && _this3.navList.current.scrollLeft < childrenScroll[index + 1];
      });
      var currentForRTL = childrenScroll.findIndex(function (item, index) {
        return _this3.navList.current.scrollLeft <= item && _this3.navList.current.scrollLeft > childrenScroll[index + 1] || _this3.navList.current.scrollLeft === item && index === childrenScroll.length - 1;
      });
      var current = reverseDirection ? currentForRTL : currentForLTR;
      var targetIndex = scrollToNext ? current + 1 : current - 1;
      this.navList.current.scrollTo({
        left: childrenScroll[targetIndex],
        behavior: "smooth"
      });
    }
  }, {
    key: "handleScrollToContentType",
    value: function handleScrollToContentType(e, name, id) {
      e.preventDefault();
      var correction = window.innerWidth > 767 ? document.getElementById("resource-center--search").clientHeight : document.getElementById("resource-center--search").clientHeight + 48;
      var targetPosition = document.getElementById(id).getBoundingClientRect().top + window.pageYOffset - correction;
      window.scrollTo({
        top: targetPosition,
        behavior: "smooth"
      });
      this.navList.current.scrollTo({
        left: e.target.offsetLeft,
        behavior: "smooth"
      });
      trackFAQCategoryClick(name, id);
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;
      var contentTypes = this.props.contentTypes;
      var _this$state = this.state,
        activeNavLinkIndex = _this$state.activeNavLinkIndex,
        listScroll = _this$state.listScroll,
        maxListScroll = _this$state.maxListScroll;
      return /*#__PURE__*/React.createElement("div", {
        className: "resource-center__search__list-navigation"
      }, contentTypes.length > 1 && /*#__PURE__*/React.createElement("button", {
        className: "resource-center__search__list-navigation__arrow prev",
        onClick: function onClick(e) {
          return _this4.handleScrollToNavLink(e, false);
        },
        disabled: listScroll === 0
      }), /*#__PURE__*/React.createElement("div", {
        className: "resource-center__search__list-navigation__container",
        ref: this.navList,
        onScroll: this.onNavListScroll
      }, contentTypes.map(function (contentType, index) {
        return /*#__PURE__*/React.createElement("button", {
          key: contentType.id,
          className: "resource-center__search__list-navigation__nav-btn ".concat(activeNavLinkIndex === index ? "active" : ""),
          onClick: function onClick(e) {
            return _this4.handleScrollToContentType(e, contentType.name, contentType.id);
          },
          dangerouslySetInnerHTML: {
            __html: contentType.name
          }
        });
      })), contentTypes.length > 1 && /*#__PURE__*/React.createElement("button", {
        className: "resource-center__search__list-navigation__arrow next",
        onClick: function onClick(e) {
          return _this4.handleScrollToNavLink(e, true);
        },
        disabled: listScroll * (reverseDirection ? -1 : 1) >= maxListScroll - 1
      }));
    }
  }]);
}(React.Component);
export default SearchListNavigation;